<template>
	<div class="h-full flex flex-col">
		<p class="text-[#616161] "><slot name="subTitle"></slot></p>
		<h6 class="text-secondary text-[1.625rem] mb-2 font-medium "><slot name="title"></slot></h6>
	</div>
</template>

<script>
export default {
	name: "SectionHeading",
	// props: ['href']
}
</script>